<template>
  <EdroneAlert
    v-if="type === 'normal'"
    :show-icon="!isVertical && showIcon"
    :type="activeUntil ? 'error' : 'caution'"
    unique-id="352e54cb-9f65-4e98-883b-2aea1d4662ed"
    class="tw:overflow-hidden"
    :is-vertical="isVertical"
    :title="
      activeUntil ? `${trans._cancellation.subsUntil} ${formattedActiveUntil}` : trans._cancellation.supportWillContact
    "
    :desc="activeUntil ? trans._cancellation.youCanRestore : trans._cancellation.activeUntilEnd"
  >
    <template #custom-content>
      <div class="tw:flex tw:gap-2" :class="{ 'tw:flex-col': isVertical }">
        <EdroneButton size="medium" @click="$emit('restore')">
          {{ trans._cancellation.restoreButton }}
          <template #left-icon>
            <FontAwesomeIcon icon="fa-light fa-arrow-rotate-left" />
          </template>
        </EdroneButton>
        <EdroneButton size="medium" type="outline" @click="$emit('chat')">
          {{ trans._cancellation.talk }}
          <template #left-icon><FontAwesomeIcon icon="fa-light fa-message-heart" /></template>
        </EdroneButton>
      </div>
    </template>
  </EdroneAlert>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { formatDateWithLocale } from "vue-app/utils/functions";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EdroneButton from "edrone-components/EdroneButton.vue";
import EdroneAlert from "edrone-components/EdroneAlert.vue";

interface Props {
  activeUntil: string | null;
  isVertical: boolean;
  type: "small" | "normal";
  showIcon: boolean;
}

const props = defineProps<Props>();
defineEmits(["restore", "chat"]);

const { lang } = window.EDRONE_CONTEXT.user;

const formattedActiveUntil = computed(() => {
  if (!props.activeUntil) return null;
  return formatDateWithLocale(props.activeUntil, lang);
});
</script>
